window.LUME = window.LUME || {};

LUME.qs = (s, r = document) => r.querySelector(s);
LUME.qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

LUME.toast = (msg) => {
  const el = document.getElementById('toast');
  if (!el) return;
  el.textContent = msg;
  el.hidden = false;
  el.classList.add('show');
  clearTimeout(LUME._toastT);
  LUME._toastT = setTimeout(() => {
    el.classList.remove('show');
    el.hidden = true;
  }, 2200);
};

LUME.formatMoney = (cents) => {
  if (window.Shopify && typeof Shopify.formatMoney === 'function') {
    try {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '{{amount}}');
    } catch (e) { /* fall through */ }
  }
  return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-PK');
};

/** FAQ + product accordion — matches final.html toggleFold */
LUME.toggleFold = (btn, itemClass) => {
  const item = btn.closest('.' + itemClass);
  if (!item) return;
  const body = item.querySelector('.faq-a, .accord-a');
  if (!body) return;
  const wasOpen = item.classList.contains('open');
  const parent = item.parentElement;
  if (parent) {
    parent.querySelectorAll('.' + itemClass + '.open').forEach((i) => {
      i.classList.remove('open');
      const b = i.querySelector('.faq-a, .accord-a');
      if (b) b.style.maxHeight = '0px';
    });
  }
  if (!wasOpen) {
    item.classList.add('open');
    body.style.maxHeight = body.scrollHeight + 'px';
  }
};

document.documentElement.classList.add('js');

document.addEventListener('click', (e) => {
  const q = e.target.closest('.faq-q, .accord-q');
  if (!q) return;
  // Product page may set data-lume-local-accord to avoid double-bind; still fine if we own it.
  if (q.closest('[data-lume-skip-fold]')) return;
  e.preventDefault();
  const item = q.closest('.faq-item, .accord-item');
  if (!item) return;
  const cls = item.classList.contains('faq-item') ? 'faq-item' : 'accord-item';
  LUME.toggleFold(q, cls);
});

window.addEventListener('resize', () => {
  document.querySelectorAll('.faq-item.open .faq-a, .accord-item.open .accord-a').forEach((b) => {
    b.style.maxHeight = b.scrollHeight + 'px';
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const sticky = document.getElementById('stickyCta');
  const hero = document.getElementById('hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting;
        sticky.classList.toggle('show', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      },
      { threshold: 0.08 }
    );
    io.observe(hero);
  }
});
